/// <reference types="@yandex-int/error-counter/dist/implementation.d.ts" />

import { get as getCookie } from 'js-cookie';
import type { InitErrorBoosterConfig } from '@adv-frontend/yastore-modules/lib';

interface ErrorBoosterOptions {
    platform: 'touch' | 'desktop';
    env: string;
}

export const getBoosterConfig = ({ platform, env }: ErrorBoosterOptions): InitErrorBoosterConfig => {
    return {
        project: 'yastore-checkout',
        page: window.location.pathname,
        env: env as Ya.Rum.LogEnvironment,
        platform,
        yandexuid: getCookie('yandexuid'),
        referrer: true,
        preventError: false,
        unhandledRejection: true,
        uncaughtException: true,
        debug: false,
        /* Отправлять не больше чем указанное количество ошибок каждого типа от одного пользователя */
        limits: {
            client: 1000,
            uncaught: 100,
            script: 100,
            external: 100,
        },
        /* На графиках выводить не больше чем указанное количество ошибок каждого типа от одного пользователя */
        silent: {
            client: 100,
            uncaught: 10,
            script: 10,
            external: 10,
        },
        initTimestamp: Date.now(),
    };
};
